import { apiToken, apiBasic, apiTokenNotDecode, logout } from "./requests";

export const logIn = (data = null) => {
  let path = "login";
  return apiTokenNotDecode(data, path);
};

export const validateLogIn = (data) => {
  let path = "validate";
  return apiBasic(data, path);
};

export const recoverPassword = (data = null) => {
  let path = "forgot-password";
  return apiBasic(data, path);
};

export const resetPassword = (data) => {
  let path = "reset-password";
  return apiToken(data, path);
};

export const logOut = () => {
  return logout();
};
